import {
  JapanPrefecture,
  I18nCountry,
  BaseGender,
  ErrorErrorID
} from '@linktivity/ars-neo';
import { LanguageCodeType, LawSettingGuarantor } from './types';

export const ErrorID = ErrorErrorID;

export const OTP_INVALID = 'OTP_INVALID';
export const OTP_MISMATCH = 'OTP_MISMATCH';

export function isOtpError(errorId: unknown): boolean {
  return (
    typeof errorId === 'string' &&
    (errorId.includes(OTP_INVALID) || errorId.includes(OTP_MISMATCH))
  );
}
export const COUPON_ERROR_ID = 'COUPON';
export const PROMOTION_ERROR_ID = 'PROMOTION';

export const ALLOTMENT_STATUS = {
  ALLOCABLE: 'allocable',
  LIMITED: 'limited',
  SOLD_OUT: 'soldOut'
} as const;

const LANGUAGE_CODE_MAP: Record<string, LanguageCodeType> = {
  en: LanguageCodeType.En,
  ja: LanguageCodeType.Ja,
  zh: LanguageCodeType.Zh,
  zt: LanguageCodeType.Zt,
  ko: LanguageCodeType.Ko
};

// TODO: 後でAPIから取得する
const lawSettingGuarantor: LawSettingGuarantor = {
  serviceName: '',
  description: '',
  companyName: 'リンクティビティ株式会社',
  representative: '代表取締役　孔　成龍',
  address: '〒100-0011 東京都千代田区内幸町2-1-6 日比谷パークフロント 19F',
  contact: 'こちら（helpcenter@linktivity.co.jp）からお問い合わせください。',
  paymentTerms:
    '以下のいずれかのお支払方法をご利用いただけます。\r\n各種クレジットカード・Alipay・Wechat Pay',
  deliverySchedule:
    '購入に関するページに特別な定めを置いている場合を除き、各種クレジットカード決済完了時、Alipay決済完了時またはWechat Pay決済完了時。',
  sellingPrice: '各商品の詳細ページをご覧ください。',
  shippingFee: 'なし。',
  additionalFee: 'インターネット接続に係る通信回線等の諸費用。',
  salesRestrictions:
    '商品ページの販売期間・在庫数・チケット枚数の制限をご参照ください。',
  returnsAndCancellations: '各商品の詳細ページをご確認ください。',
  otherConditions:
    '特別な販売条件又は提供条件がある場合、各商品の詳細ページにおいて条件を表示します。'
};

export {
  LANGUAGE_CODE_MAP,
  JapanPrefecture,
  I18nCountry,
  BaseGender,
  lawSettingGuarantor
};
